// Header.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import myLogo from './assets/images/logo.png';
import { useUser } from './usersContext';
import { useDeviceDetection } from './hooks/useDeviceDetection';
import './Header.css';  // your .fixed-header styles
import './headerbuttons.css'; // styles for the buttons, etc.
import './logo.css'; // styles for the buttons, etc.
import './signup.css';
import './signin.css'
import './dashbutton.css'

function Header() {
  const { currentUser, userDoc, userStatus, signInWithGoogle, signOutUser, resendVerificationEmail } = useUser();
  const { deviceType, isMobile } = useDeviceDetection();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleSignOut = async () => {
    try {
      await signOutUser();
    } catch (error) {
      console.error('Sign-out error:', error);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Parent nav container
  const navStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between', // ensures left & right are separated
    height: '60px', // match your .fixed-header height if needed
    width: '100%',
  };

  // Left side: logo, site title, nav links
  const leftNavStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem', // spacing between items
  };
  const googleButtonStyle_signup = {
    backgroundColor: '#DCD4F9',
    color: '#000',
    border: 'none',
    padding: '0.5rem 1rem',
    borderRadius: '4px',
    fontWeight: 'bold',
    cursor: 'pointer',
    textDecoration: 'none', // removes underline if we wrap in a Link
  };

  const googleButtonStyle_signin = {
    backgroundColor: '#000',
    opacity: '0.1',
    color: '#000',
    border: 'none',
    padding: '0.5rem 1rem',
    borderRadius: '4px',
    fontWeight: 'bold',
    cursor: 'pointer',
    textDecoration: 'none', // removes underline if we wrap in a Link
  };

  // Right side: sign in / register buttons
  const rightNavStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
  };

  // Determine if user is a non-tutor (student)
  const isStudent = currentUser && userDoc && 
                    userDoc.userType && 
                    userDoc.userType.toLowerCase() !== 'tutor';

  return (
    <header className="fixed-header" style={{ 
      backgroundColor: isMobile ? '#003366' : '#002244' // Slightly lighter blue for mobile
    }}>
      <nav style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
      }}>
        {isMobile ? (
          // Mobile Layout
          <>
            {/* Mobile Left: Logo and Dropdown Menu Button */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <Link to="/">
                <img src={myLogo} alt="Logo" className='logobutton' style={{ height: '40px', width: 'auto' }} />
              </Link>
              <button 
                onClick={toggleMenu}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'white',
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                  padding: '0.5rem'
                }}
              >
                ☰
              </button>
            </div>

            {/* Mobile Right: Auth Buttons */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              {currentUser && userStatus === 'verified' && (
                <>
                  <Link to="/Dashboard" style={{ textDecoration: 'none' }}>
                    <button className="dashbutton" style={{ fontSize: '0.8rem', padding: '0.3rem 0.6rem' }}>Dashboard</button>
                  </Link>
                  <button className="signup" style={{ fontSize: '0.8rem', padding: '0.3rem 0.6rem' }} onClick={handleSignOut}>Sign out</button>
                </>
              )}
              
              {currentUser && userStatus !== 'verified' && (
                <>
                  <Link to="/Auth" style={{ textDecoration: 'none' }}>
                    <button className="dashbutton" style={{ fontSize: '0.8rem', padding: '0.3rem 0.6rem' }}>Verify</button>
                  </Link>
                  <button className="signup" style={{ fontSize: '0.8rem', padding: '0.3rem 0.6rem' }} onClick={handleSignOut}>Sign out</button>
                </>
              )}
              
              {!currentUser && (
                <>
                  <Link to="/Auth" style={{ textDecoration: 'none' }}>
                    <button className="signin" style={{ fontSize: '0.8rem', padding: '0.3rem 0.6rem' }}>Sign in</button>
                  </Link>
                  <Link to="/register" style={{ textDecoration: 'none' }}>
                    <button className="signup" style={{ fontSize: '0.8rem', padding: '0.3rem 0.6rem' }}>Register</button>
                  </Link>
                </>
              )}
            </div>
          </>
        ) : (
          // Desktop Layout (original)
          <>
            <div style={leftNavStyle}>
              <Link to="/">
                <img src={myLogo} alt="Logo" className='logobutton' />
              </Link>
              <h1 style={{ 
                margin: 0, 
                fontSize: '1.25rem',
                marginRight: '2rem' 
              }}>
                Bright Bridge Tutors
              </h1>
              <Link to="/" className="headerbuttons">Home</Link>
              <Link to="/meet-tutors" className="headerbuttons">Meet The Tutors</Link>
              <Link to="/Form" className="headerbuttons">Book A Consultation</Link>
            </div>

            {/* Right Side */}
            <div style={rightNavStyle}>
              {currentUser && userStatus === 'verified' && (
                <>
                  <Link to="/Dashboard" className="dashbutton">Dashboard</Link>
                  <button className="signup" onClick={handleSignOut}>Sign out</button>
                </>
              )}
              
              {currentUser && userStatus !== 'verified' && (
                <>
                  <Link to="/Auth" className="dashbutton">Verify Account</Link>
                  <button className="signup" onClick={handleSignOut}>Sign out</button>
                </>
              )}
              
              {!currentUser && (
                <>
                  <Link to="/Auth" style={{ textDecoration: 'none' }}>
                    <button className="signin">Sign in</button>
                  </Link>
                  <Link to="/register">
                    <button className="signup">Register</button>
                  </Link>
                </>
              )}
            </div>
          </>
        )}
      </nav>

      {/* Mobile Dropdown Menu */}
      {isMobile && isMenuOpen && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          width: '100%',
          backgroundColor: '#003366',
          borderTop: '1px solid #004488',
          zIndex: 1000,
          boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            padding: '1rem 0'
          }}>
            <Link 
              to="/" 
              className="headerbuttons"
              style={{
                color: 'white',
                textDecoration: 'none',
                padding: '0.75rem 1rem',
                borderBottom: '1px solid #004488',
                fontSize: '1rem'
              }}
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </Link>
            <Link 
              to="/meet-tutors" 
              className="headerbuttons"
              style={{
                color: 'white',
                textDecoration: 'none',
                padding: '0.75rem 1rem',
                borderBottom: '1px solid #004488',
                fontSize: '1rem'
              }}
              onClick={() => setIsMenuOpen(false)}
            >
              Meet The Tutors
            </Link>
            <Link 
              to="/Form" 
              className="headerbuttons"
              style={{
                color: 'white',
                textDecoration: 'none',
                padding: '0.75rem 1rem',
                fontSize: '1rem'
              }}
              onClick={() => setIsMenuOpen(false)}
            >
              Book A Consultation
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}

export default Header;
